var _rect, _rect2, _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiIconImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 87,
    viewBox: "0 0 72 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7290_15718)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7290_15718)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 23,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_7290_15718)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7290_15718)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7290_15718)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 23,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint1_linear_7290_15718)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7290_15718",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 23,
    width: 40,
    height: 40
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 43,
    r: 20,
    fill: "url(#paint2_linear_7290_15718)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7290_15718)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter2_f_7290_15718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9381 63.3226C43.9381 77.8279 32.1792 89.5868 17.6739 89.5868C3.16854 89.5868 -30.2197 68.0432 -30.2197 53.5379C-24.8124 49.933 -22.6281 49.2077 -15.9333 46.6328C-5.60149 46.3679 5.61649 37.6033 17.9762 36.8308C31.7519 36.301 40.759 52.461 52.4353 58.4302C55.1177 62.5539 45.9557 60.663 43.9381 63.3226Z",
    fill: "#1859B4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-58.0459 87.6717C-36.013 58.0006 -13.3282 62.815 -1.63702 55.7217C11.6254 47.6756 20.153 46.9944 26.9371 49.6698C27.9772 50.0801 28.9767 50.57 29.9457 51.1233M128.114 100.009C97.8297 57.8457 82.2531 75.6833 65.8487 73.6407C61.3711 73.0832 57.5705 71.7996 54.2228 70.0907M54.2228 70.0907C52.1006 70.0058 46.7664 70.5208 42.4078 73.2573M54.2228 70.0907C53.1994 69.568 52.2178 69.0057 51.2728 68.4118M51.2728 68.4118C44.4983 67.6826 38.2897 71.4204 27.7104 73.6401M51.2728 68.4118C50.2607 67.776 49.2899 67.1048 48.3521 66.408M48.3521 66.408C42.8594 65.8362 34.3755 70.0907 25.303 72.1172M48.3521 66.408C47.6624 65.896 46.9907 65.3697 46.334 64.8337M17.6014 73.2573C35.9121 69.0153 40.4968 64.1046 46.3334 64.8337C45.5606 64.2039 44.8087 63.5603 44.0724 62.9107M16.8094 72.8577C30.9577 68.6008 34.6476 62.9107 44.073 62.9107C43.7931 62.6637 43.5156 62.4167 43.2404 62.1678M43.2404 62.1678C29.9038 61.2371 29.332 67.7353 13.5957 72.8571M43.2404 62.1678C42.747 61.7234 42.2601 61.2772 41.7774 60.8316M41.7774 60.8316C27.7104 58.7202 23.7502 69.1624 8.17896 73.6401M41.7774 60.8316C41.2067 60.3047 40.6433 59.7783 40.0829 59.2561M40.0829 59.2561C16.8088 59.2561 24.1557 64.8337 8.17896 70.0907C-1.44682 73.2573 -7.59923 66.0755 -23.3876 72.8577M40.0829 59.2561C39.3789 58.5994 38.6814 57.9498 37.9846 57.3134M-27.5871 73.6401C-17.7149 63.9975 -1.10289 72.8577 10.0487 65.6645C25.352 55.7935 32.4967 57.0849 37.9852 57.3134C37.4864 56.8582 36.9881 56.4096 36.4881 55.97M36.4881 55.97C36.4881 55.97 21.0054 52.3477 4.19778 64.4497C-5.28385 71.2774 -20.2522 63.9766 -30.1214 73.2573M36.4881 55.97C35.8002 55.3659 35.11 54.7797 34.4113 54.2186M34.4113 54.2186C34.4113 54.2186 20.601 49.2858 2.75029 62.1678C-6.41971 68.7856 -24.5546 63.9766 -33.9812 73.2573M34.4113 54.2186C33.7959 53.724 33.1738 53.2491 32.5428 52.7975M32.5428 52.7975C32.5428 52.7975 20.9707 48.7906 8.17896 57.125C-11.3418 69.8431 -22.9444 61.5697 -39.1915 74.1443M32.5428 52.7975C31.697 52.1928 30.8339 51.6305 29.9457 51.1233M29.9457 51.1233C29.9457 51.1233 17.6014 46.5452 3.31254 57.747C-6.54353 65.4731 -26.0122 61.62 -39.493 73.2573M26.9371 49.6704C10.0481 46.8993 2.75029 58.3434 -24.5546 63.9772C-33.438 67.1084 -38.4731 69.0996 -41.6409 73.6407",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58.0459 84.7357C-28.2002 50.1994 -17.6311 61.6968 -1.63702 52.7863C37.9092 30.7547 35.2894 68.0687 65.6423 71.8489C82.0468 73.8921 99.0266 58.6193 128.114 97.0728",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.1426 82.3248C-27.2969 47.7885 -16.5699 59.564 -0.733704 50.3755C38.1349 27.8228 36.7831 66.0986 67.136 69.8788C83.5405 71.9215 100.533 57.4137 130.818 99.5768",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.1426 80.2332C-23.8528 46.1611 -16.3689 57.2433 -0.532728 48.0548C38.3359 25.5021 37.2813 63.9077 67.6343 67.6874C84.0387 69.73 100.533 55.3215 130.818 97.4846",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.1426 78.2402C-22.2582 44.4671 -17.0137 55.1941 -0.931108 45.8626C37.9375 23.3099 38.0786 61.6156 68.4315 65.3958C84.836 67.4391 100.534 53.3291 130.818 95.4928",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.2383 75.162C-27.7395 46.3606 -16.9133 53.2009 -0.83182 43.8694C37.0845 21.8694 38.3777 59.4233 68.7306 63.2035C85.135 65.2461 100.533 51.635 130.818 93.7981",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58.2656 72.5513C-29.4337 45.8589 -16.9136 50.7618 -0.831548 41.4309C37.0848 19.4309 38.378 56.9848 68.7309 60.7644C85.1353 62.8077 104.64 50.6805 134.925 92.8436",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58.2656 68.9851C-31.471 44.0243 -19.22 51.6111 -1.21316 40.0509C35.6768 16.369 38.378 54.6406 68.7309 58.4202C85.1353 60.4635 104.64 48.3363 134.925 90.4994",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58.2656 66.237C-31.471 41.2762 -19.22 48.8629 -1.21316 37.3028C35.6768 13.6209 38.7315 53.0834 69.0844 56.8636C85.4888 58.9068 103.622 46.8795 134.925 87.7513",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.124 62.9301C-29.3294 37.9693 -21.6099 48.3763 -1.21348 35.2825C34.2637 12.5073 38.3268 52.8407 68.6797 56.621C81.8267 58.2586 85.4754 46.147 98.221 56.621C110.967 67.0949 144.647 67.8521 144.647 67.8521",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.124 60.6972C-29.3294 35.737 -21.2606 45.9795 -0.863569 32.8857C34.6136 10.1105 38.7664 51.1527 69.1194 54.9323C82.2664 56.57 85.6721 43.56 99.5106 54.9323C113.349 66.3047 144.647 65.6186 144.647 65.6186",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.124 58.7817C-29.3294 33.8209 -21.2606 44.064 -0.863562 30.9696C34.6136 8.19442 38.9495 49.2312 69.3024 53.0108C82.4494 54.6485 85.2319 44.5502 96.6551 51.0896C108.078 57.629 128.171 62.2341 143.768 60.329",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-54.4395 54.2285C-27.6448 29.2684 -22.9542 43.1774 -2.55726 30.0836C32.9199 7.30846 40.0245 47.4552 70.3775 51.2355C83.5245 52.8731 85.2327 43.952 96.6559 50.4914C108.079 57.0308 128.813 60.424 144.409 58.5189",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53.5703 51.9361C-26.7757 26.9754 -22.0851 40.8844 -1.68812 27.7906C33.789 5.01547 40.2567 45.691 70.609 49.4712C83.756 51.1083 86.0152 42.9318 97.4383 49.4712C108.862 56.0106 129.681 58.131 145.278 56.2259",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53.5703 50.1187C-26.7757 25.1586 -23.4118 36.7235 -1.68812 25.9738C41.5247 4.5899 40.6287 42.7108 70.9816 46.491C84.1286 48.1281 86.8848 42.063 98.3074 48.6024C109.731 55.1418 129.681 56.3142 145.278 54.4091",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53.5703 44.9388C-26.7757 19.978 -23.1815 31.9963 -1.68811 20.7933C42.6624 -2.32341 39.5838 39.4228 69.9876 42.764C81.2905 44.0063 87.3658 37.7229 100.294 45.1242C113.223 52.5255 129.681 51.1343 145.278 49.2292",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53.5703 40.8927C-26.7757 15.9319 -24.3592 25.3209 -1.68811 16.7472C47.7549 -1.95109 39.5838 35.3767 69.9876 38.7179C81.2905 39.9602 87.3658 33.6768 100.294 41.0781C113.223 48.4794 129.681 47.0882 145.278 45.1831",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53.5703 37.5013C-26.7757 12.5406 -24.3592 21.9301 -1.68811 13.3558C47.7549 -5.34245 39.5838 31.9853 69.9876 35.3265C81.2905 36.5688 87.3658 30.2854 100.294 37.6868C113.223 45.0881 129.681 43.6968 145.278 41.7918",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53.5703 34.0504C-26.7757 9.08965 -24.3592 18.4792 -1.68811 9.90491C47.7549 -8.79338 39.5838 28.5344 69.9876 31.8756C81.2905 33.1179 87.3658 26.8339 100.294 34.2358C113.223 41.6371 129.681 40.2459 145.278 38.3408",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.4209 30.3109C-25.6263 5.35015 -23.2098 14.7397 -0.538703 6.16541C48.9043 -12.5329 40.7332 24.7949 71.1376 28.1361C82.4405 29.3784 88.5152 23.095 101.444 30.4963C114.374 37.8976 130.831 36.5064 146.428 34.6013",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-51.5566 26.5632C-24.7626 1.60308 -22.3455 10.992 0.325551 2.41834C49.7686 -16.2799 41.5974 21.0478 72.0018 24.389C83.3048 25.6313 89.3794 19.3479 102.309 26.7493C115.237 34.1506 131.696 32.7593 147.292 30.8543",
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 0.580852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9451 44.7899C33.027 45.6444 32.054 46.4589 30.9396 47.0342C29.8251 47.6096 28.5507 47.9355 27.3079 47.7648C25.7084 47.545 24.2542 46.4612 23.5866 44.9917C22.919 43.5222 23.0605 41.7145 23.9485 40.3666C24.1481 40.0634 24.3845 39.7856 24.6487 39.5375C25.8811 38.3854 27.6552 38.0001 29.2802 38.4519C34.2263 39.8328 37.0389 45.4105 41.7449 47.4757C42.4749 47.7888 43.2873 48.0171 44.0871 48.0345C48.0877 48.1482 50.261 42.7888 47.7716 39.7215C46.86 38.5594 45.4035 37.9053 43.9323 37.9515C42.6107 37.9916 41.4246 38.533 40.2993 39.2234C39.4136 39.7644 38.6658 40.4501 37.9911 41.2169",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7290_15718",
    x: 0,
    y: 15,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.4 0 0 0 0 0.745098 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7290_15718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7290_15718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7290_15718",
    x: 0,
    y: 15,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.4 0 0 0 0 0.745098 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7290_15718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7290_15718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_7290_15718",
    x: -30.2778,
    y: 36.76,
    width: 83.2592,
    height: 52.885,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0290426,
    result: "effect1_foregroundBlur_7290_15718"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7290_15718",
    x1: 17.7333,
    y1: 22.9997,
    x2: 58.1487,
    y2: 26.3725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F62C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7290_15718",
    x1: 17.7333,
    y1: 22.9997,
    x2: 58.1487,
    y2: 26.3725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F62C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7290_15718",
    x1: 17.7333,
    y1: 22.9997,
    x2: 58.1487,
    y2: 26.3725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F62C0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7290_15718"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 23,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7290_15718"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 23,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIconImg);
export default __webpack_public_path__ + "static/media/aiIconImg.2df7c03a5ce01dc93f8d0ce42580068c.svg";
export { ForwardRef as ReactComponent };